import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Util } from '@shared/common/utils/util';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';
import { IObtenerCertificadoOfertaResponse } from '@interfaces/certificado-oferta.interface';
import { DIAS_VIGENCIA_CERTIFICADO_OFERTAS } from '@constants/tramite-pension-constant';

@Injectable({
  providedIn: 'root'
})
export class CertificadoOfertaService {

  constructor(
    private readonly http: HttpClient,
    private readonly util: Util
  ) { }

  public async getCerfificadoOferta(): Promise<{ tieneCertificadoOferta: boolean, fechaEmision: string, fechaVencimiento: string }> {
    try {
      const token = await this.util.getIdToken();

      const url = `${environment.BASE_BACKEND}/certificados/certificado-oferta`;
      const headers = this.util.getHeaders(token);

      const { data } = await firstValueFrom(this.http.get<IObtenerCertificadoOfertaResponse>(url, { headers }));
      if (data.informacion.codigo === "1") {
        return {
          tieneCertificadoOferta: true,
          fechaEmision: data.certificado.fechaEmisionCertificadoOferta,
          fechaVencimiento: data.certificado.fechaVencimientoOferta ?? this.util.addDaysToDate(data.certificado.fechaEmisionCertificadoOferta, DIAS_VIGENCIA_CERTIFICADO_OFERTAS),
        }
      }
      return {
        tieneCertificadoOferta: false,
        fechaEmision: '',
        fechaVencimiento: '',
      }
    } catch (error) {
      console.error('Error al obtener el certificado de oferta:', error);
      return {
        tieneCertificadoOferta: false,
        fechaEmision: '',
        fechaVencimiento: '',
      }
    }
  }

  public async descargarCertificadoOferta(): Promise<void> {
    try {
      const token = await this.util.getIdToken();
      const url = `${environment.BASE_BACKEND}/certificados/certificado-oferta-obtener`;
      const headers = this.util.getHeaders(token);
      const { data } = await firstValueFrom(this.http.get<IObtenerCertificadoOfertaResponse>(url, { headers }));
      if (!data.certificado.documento) throw new Error('No se encontró el certificado de oferta');
      const pdfBlob = this.base64ToBlob(data.certificado.documento, 'application/pdf');
      // 🔹 5. Generar el archivo ZIP y descargarlo
      const fecha = new Date().toISOString().slice(0, 10);
      saveAs(pdfBlob, `certificados_oferta_${fecha}.pdf`);

    } catch (error) {
      console.error('Error al generar ZIP de certificados:', error);
      throw error;
    }
  }

  /** 🔧 Helper para convertir Base64 → Blob */
  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.codePointAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type });
  }

}
